<template>
  <helper-layout :loaded="mx_loaded">
    <material-table
      :search-data="searchData"
      :headers="headers"
      :items="customerList.items"
      :paginate="paginateConfig"
      :sort-data.sync="sortData"
      :total-count="customerList.totalCount"
      @pageChange="handlePageChange"
      @sortChange="handleSortChange"
      @selectChange="handleSelectChange"
      @searchChange="handleSearchChange"
    >
      <!-- 表格顶部工具栏 -->
      <template v-slot:toolbar>
        <v-layout justify-end class="toolbar">
          <v-flex shrink>
            <v-btn
              v-if="getPermission('CustomerManager.CustomerList.CreateOrEdit')"
              solid
              color="success"
              @click="handleAddNew"
            >
              <!-- 新增 -->
              {{ $t("Views.Customer.new") }}
            </v-btn>

            <!-- 批量导入（弥生） -->
            <v-btn
              v-if="getPermission('CustomerManager.CustomerList.Import')"
              hollow
              color="success"
              @click="handleImport"
            >
              {{ $t("Views.Customer.batchImport") }}
            </v-btn>
            <!-- 批量导入（Smile）-->
            <v-btn
              v-if="getPermission('CustomerManager.CustomerList.Import')"
              hollow
              color="success"
              @click="handleImportNew"
            >
              {{ $t('Views.Customer.batchImportNew') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
    </material-table>

    <material-dialog
      :visible="showDialog"
      :title="$t('Views.Customer.sure')"
      width="640"
      @cancleFn="handleCloseDialog"
      @confirmFn="handleSubmitDialog"
    >
      <template>
        <span v-if="updateStatusItem.isNormal == 'Active'" class="desc">
          <span>{{ $t("Views.Customer.sureBan") }}</span>
          <span> {{ $t("Views.Customer.banDesc") }}</span>
        </span>

        <span v-else class="desc">
          <span>{{ $t("Views.Customer.sureActive") }}</span>
          <span> {{ $t("Views.Customer.activeDesc") }}</span>
        </span>
        <v-textarea v-model="remark" counter maxlength="50" name="input-7-1" :label="$t('Views.Customer.remark')" />
      </template>
    </material-dialog>
    <!-- 重置密码弹窗 -->
    <material-dialog
      :visible="showResetConfirm"
      :title="$t('Views.Customer.sure')"
      width="640"
      @cancleFn="resetCancel"
      @confirmFn="resetConfirm"
    >
      <template>
        <span class="desc">
          <span>{{ $t("Views.Customer.reset_tip", {0: resetCustomer.name }) }}</span>
        </span>
      </template>
    </material-dialog>
  </helper-layout>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { pageLoadMx } from '@/plugins/mixins'
import ENUMS from '@/dict/enums'

export default {
  mixins: [pageLoadMx],
  data() {
    const $t = this.$t.bind(this)
    return {
      headers: [
        {
          text: $t('Views.Customer.customerName'),
          value: 'name'
        },
        // {
        //   text: $t('Views.Customer.contactPerson'),
        //   value: 'extensions.contactPerson',
        //   type: 'nest',
        //   width: 200
        // },
        // {
        //   text: $t('Views.Customer.address'),
        //   value: 'address',
        //   render: (h, param) => {
        //     return h('material-tooltip',
        //       { props: {
        //         content: this.renderAddress(param) || '--',
        //         oWidth: 400,
        //         diableColor: param.row.grayRow ? this.disableColor : ''
        //       }
        //       })
        //   },
        //   width: 450
        // },
        // {
        //   text: $t('Views.Customer.serialNumber'),
        //   value: 'serialNumber',
        //   cls: 'mail-cls',
        //   width: 150
        // },
        {
          text: $t('Views.Customer.newSerialNumberList'),
          value: 'newSerialNumber',
          width: 150,
          renderHeader: (h, params) => {
            return h(
              'div',
              {
                domProps: {
                  innerHTML: $t('Views.Order.newCustomerNumList')
                }
              }
            )
          },
          render: (h, param) => {
            const text = param.row.newSerialNumber && param.row.serialNumber ? param.row.newSerialNumber : param.row.newSerialNumber ? param.row.newSerialNumber : param.row.serialNumber
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        },
        {
          // 账号ID
          text: $t('Views.Customer.accountID'),
          value: 'accountId',
          width: 120
        },
        {
          text: $t('Views.Setting.customer_level_label'),
          value: 'level',
          width: 120,
          render: (h, param) => {
            return h('div', this.renderLevel(param.row.levelId) || '--')
          }
        },
        {
          text: $t('Views.Customer.sales'),
          value: 'sale.staff.name',
          width: 140,
          type: 'nest'
        },
        // {
        //   text: $t('Views.Customer.signDate'),
        //   value: 'signDate',
        //   type: 'date',
        //   width: 120
        // },
        // {
        //   text: $t('Views.Customer.dpt_approve_status'),
        //   value: 'departmentsWorkflows',
        //   render: (h, param) => {
        //     return h('div', param.row.departmentsWorkflows.map(i => {
        //       return [h('span', i.name + ': '),
        //         h(
        //           'span',
        //           {
        //             style: {
        //               color: ENUMS.departmentStatus[i.status].color
        //             },
        //             class: 'status mr-10'
        //           },
        //           ENUMS.departmentStatus[i.status].text
        //         )]
        //     })
        //     )
        //   }
        // },
        // {
        //   text: $t('Views.Customer.sale_dpt') + $t('Views.Customer.approve_status'),
        //   value: 'saleDepartmentReviewStatus',
        //   render: (h, param) => {
        //     return h(
        //       'div',
        //       {
        //         style: {
        //           color: ENUMS.departmentStatus[param.row.saleDepartmentReviewStatus].color
        //         },
        //         class: 'status'
        //       },
        //       ENUMS.departmentStatus[param.row.saleDepartmentReviewStatus].text)
        //   }
        // },
        // {
        //   text: $t('Views.Customer.manager_dpt') + $t('Views.Customer.approve_status'),
        //   value: 'managerDepartmentReviewStatus',
        //   render: (h, param) => {
        //     return h(
        //       'div',
        //       {
        //         style: {
        //           color: ENUMS.departmentStatus[param.row.managerDepartmentReviewStatus].color
        //         },
        //         class: 'status'
        //       },
        //       ENUMS.departmentStatus[param.row.managerDepartmentReviewStatus].text)
        //   }
        // },
        {
          text: $t('Views.Customer.status'),
          value: 'status',
          width: 100,
          render: (h, param) => {
            return h(
              'div',
              {
                style: {
                  color: ENUMS.customerStatus[param.row.status] ? ENUMS.customerStatus[param.row.status].color : '#000'
                },
                class: ENUMS.customerStatus[param.row.status] && 'status'
              },
              ENUMS.customerStatus[param.row.status] ? ENUMS.customerStatus[param.row.status].text : '--'
            )
          }
        },
        {
          text: $t('Views.Customer.action'),
          value: 'action',
          width: 220,
          actions: [
            {
              text: $t('Views.Customer.view'),
              color: this.$store.state.app.color,
              visible: true,
              actionFn: row => {
                this.$router.push({
                  name: 'customerDetail',
                  query: { id: row.row.id }
                })
              }
            },
            {
              text: $t('Views.Customer.edit'),
              color: this.$store.state.app.editBtnColor,
              visible: row => {
                return this.$util.tool.hasPerm('CustomerManager.CustomerList.CreateOrEdit')
              },
              actionFn: row => {
                this.$router.push({
                  name: 'customerEdit',
                  query: { id: row.row.id, isEdit: true }
                })
              }
            },
            {
              actionFn: row => {
                this.confirmItem(row.row)
              },
              text: $t('Views.Customer.banned'),
              color: this.$store.state.app.banBtnColor,
              visible: row => {
                return (
                  row.row.status === 'Active' &&
                  this.$util.tool.hasPerm(
                    'CustomerManager.CustomerList.ToggleActive'
                  )
                )
              }
            },
            {
              actionFn: row => {
                this.confirmItem(row.row)
              },
              text: $t('Views.Customer.active'),
              color: this.$store.state.app.warnBtnColor,
              visible: row => {
                return (
                  row.row.status === 'InActive' &&
                  this.$util.tool.hasPerm(
                    'CustomerManager.CustomerList.ToggleActive'
                  )
                )
              }
            },
            {
              text: $t('Views.Customer.reset_code_btn'),
              color: this.$store.state.app.payBtnColor,
              visible: () => this.$util.tool.hasPerm('CustomerManager.CustomerList.ResetPassword'),
              actionFn: row => {
                this.resetCustomer = { name: row.row.name, id: row.row.id }
                this.showResetConfirm = true
              }
            }
            // {
            //   text: $t('Views.Customer.review'),
            //   color: this.$store.state.app.color,
            //   visible: row => {
            //     return (
            //       row.row.status === 'WaitReview' &&
            //       this.$util.tool.hasPerm(
            //         'CustomerManager.CustomerList.Review'
            //       )
            //     )
            //   },
            //   actionFn: row => {
            //     this.$router.push({
            //       name: 'customerDetail',
            //       query: { id: row.row.id }
            //     })
            //   }
            // },
            // {
            //   text: $t('Views.Customer.affirm'),
            //   color: this.$store.state.app.color,
            //   visible: row => {
            //     return (
            //       row.row.status === 'WaitConfirm' &&
            //       this.$util.tool.hasPerm(
            //         'CustomerManager.CustomerList.Confirm'
            //       )
            //     )
            //   },
            //   actionFn: row => {
            //     this.$router.push({
            //       name: 'customerDetail',
            //       query: { id: row.row.id }
            //     })
            //   }
            // }
          ]
        }
      ],
      // 表格数据检索配置
      searchData: [
        {
          key: 'filter',
          value: '',
          label: $t('Views.Customer.name'),
          placeholder: $t('Views.Customer.name_SN_contactor')
        },
        {
          key: 'salesId',
          type: 'select',
          name: $t('Views.Customer.sales'),
          placeholder: $t('Views.Customer.selectSales'),
          itemText: 'name',
          itemValue: 'id',
          id: '',
          state: []
        },
        // {
        //   key: 'dateRange',
        //   label: $t('Views.Customer.filingDate'),
        //   value: {},
        //   type: 'daterange',
        //   icon: 'mdi-calendar'
        // },
        // {
        //   key: 'saleDepartmentReviewStatus',
        //   label: $t('Views.Customer.sale_dpt') + $t('Views.Customer.approve_status'),
        //   placeholder: $t('Views.Customer.selectStatus'),
        //   value: '',
        //   type: 'select',
        //   state: [
        //     ...this.$util.tool.enumToSelect(ENUMS.departmentStatus)
        //   ]
        // },
        // {
        //   key: 'managerDepartmentReviewStatus',
        //   label: $t('Views.Customer.manager_dpt') + $t('Views.Customer.approve_status'),
        //   placeholder: $t('Views.Customer.selectStatus'),
        //   value: '',
        //   type: 'select',
        //   state: [
        //     ...this.$util.tool.enumToSelect(ENUMS.departmentStatus)
        //   ]
        // },
        {
          key: 'status',
          // 状态
          label: $t('Views.Customer.status'),
          placeholder: $t('Views.Customer.selectStatus'),
          type: 'select',
          value: '',
          state: [...this.$util.tool.enumToSelect(ENUMS.customerStatus)]
        }
      ],
      // 表格分页配置
      paginateConfig: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      // 表格排序配置
      sortData: {
        descending: false
      },
      // 表格行已选数据
      selectData: [],
      // 表格搜索项
      form: {
        filter: '',
        salesId: '',
        status: '',
        sorting: '',
        skipCount: 0,
        maxResultCount: 10
      },
      showDialog: false,
      updateStatusItem: {},
      remark: '',
      showResetConfirm: false,
      resetCustomer: {}
    }
  },
  computed: {
    color() {
      return this.$store.state.app.color
    },
    ...mapState('app', ['color', 'disableColor']),
    ...mapState('customer', ['customerList', 'regionTree', 'customerLevel'])
  },
  mounted() {
    if (this.$route.query.saleDepartmentReviewStatus) {
      this.searchData[3].value = this.$route.query.saleDepartmentReviewStatus
      this.form.saleDepartmentReviewStatus = this.$route.query.saleDepartmentReviewStatus
    }
    if (this.$route.query.managerDepartmentReviewStatus) {
      this.searchData[4].value = this.$route.query.managerDepartmentReviewStatus
      this.form.managerDepartmentReviewStatus = this.$route.query.managerDepartmentReviewStatus
    }
    if (this.$route.query.status) {
      this.searchData[2].value = this.$route.query.status
      this.form.status = this.$route.query.status
    }
    this.getCustomerLevel()
    this.getStaff()
    this.getPage()
  },
  methods: {
    ...mapActions('customer', [
      'getCutomerList',
      'getRegionTree',
      'updCustomerActive',
      'getCustomerLevel',
      'customerResetCode'
    ]),
    ...mapActions('setting', ['getStaffAllData']),
    getPermission(name) {
      return this.$util.tool.hasPerm(name)
    },
    getPage(page) {
      if (typeof page !== 'undefined') {
        this.paginateConfig.page = page
        this.form.skipCount = (page - 1) * this.form.maxResultCount
      }
      if (!this.mx_loaded) this.mx_loading_fn() // 页面加载中
      this.getCutomerList(this.form).then(() => {
        this.paginateConfig.total = this.customerList.totalCount
        this.mx_loaded_fn() // 页面加载完成
      })
    },
    getStaff() {
      this.getStaffAllData({ isActive: true, permissionCheck: true }).then(
        (ret) => {
          this.searchData[1].state = ret.items
        }
      )
    },
    getRegion() {
      this.getRegionTree().then(() => {
        this.searchData[3].items = this.regionTree
      })
    },
    handleSearchChange(search) {
      this.form = { ...this.form, ...search }
      if (search.dateRange) {
        this.form = {
          ...this.form,
          ...{ creationTimeBegin: search.dateRange.start },
          ...{ creationTimeEnd: search.dateRange.end }
        }
      }
      delete this.form.dateRange
      this.getPage(1)
    },
    handlePageChange(page) {
      this.getPage(page)
    },
    handleSortChange(sort) {
      const value_sort = `${sort.sortBy}`
      const value_desc = sort.descending ? ' desc' : ''
      const value = value_sort + value_desc
      if (value === this.form.sorting) return
      this.form.sorting = value
      this.getPage()
    },
    handleSelectChange(selected) {
      this.selectData = selected
    },
    renderAddress(param) {
      return (param.row.region ? param.row.region.fullName : '') + (param.row.address || '')
    },
    handleAddNew() {
      this.$router.push({
        name: 'customerCreate'
      })
    },
    handleImport() {
      this.$router.push({
        name: 'importCustomer'
      })
    },
    handleImportNew() {
      this.$router.push({
        name: 'importCustomerNew'
      })
    },
    confirmItem(row) {
      this.showDialog = true
      this.updateStatusItem.id = row.id
      this.updateStatusItem.isNormal = row.status
    },
    handleCloseDialog() {
      this.showDialog = false
      this.remark = ''
      this.updateStatusItem = {}
    },
    handleSubmitDialog() {
      this.updCustomerActive({
        id: this.updateStatusItem.id.toString(),
        form: { remark: this.remark }
      })
        .then(data => {
          this.updateStatusItem = {}
          this.remark = ''
          this.showDialog = false
          this.$store.commit('app/setNotification', {
            msg: this.$t('Views.Customer.success'),
            type: 'success'
          })
          this.getPage()
        })
        .catch(err => {
          this.$store.commit('app/setNotification', {
            msg: err.error.message,
            type: 'error'
          })
        })
        .finally(() => {
          this.requestLoading = false
        })
    },
    renderLevel(levelId) {
      const level = this.customerLevel.items && this.customerLevel.items.find(c => c.id === levelId)
      return level && level.name
    },
    resetConfirm() {
      this.customerResetCode(this.resetCustomer.id).then(() => {
        this.resetCustomer = {}
        this.showResetConfirm = false
        this.$store.commit('app/setNotification', {
          msg: this.$t('Views.Customer.success'),
          type: 'success'
        })
      })
    },
    resetCancel() {
      this.resetCustomer = {}
      this.showResetConfirm = false
    }
  }
}
</script>

<style>
.mail-cls {
  max-width: 300px;
  word-break: break-all;
}
.desc {
  font-size: 14px;
  color: #515151;
}
.mr-10 {
  margin-right: 20px;
}
</style>
